import { Fragment } from 'react';
import { Transition } from '@headlessui/react';

const classNames = (...classes) => classes.filter(Boolean).join(' ');

const DEFAULT_TRANSITION = {
  enter: 'c-dropdown-menu--enter',
  enterFrom: 'c-dropdown-menu--enter-from',
  enterTo: 'c-dropdown-menu--enter-to',
  leave: 'c-dropdown-menu--leave',
  leaveFrom: 'c-dropdown-menu--leave-from',
  leaveTo: 'c-dropdown-menu--leave-to',
};

export default function DropdownMenu({
  item,
  baseKey,
  mapLinkAttributes,
  useGrid = false,
  isOpen = false,
  transition = DEFAULT_TRANSITION,
  allowNested = true,
  align = 'full',
  isCompact = false,
  offset = 'none',
}) {
  const isCentered = align === 'center';
  const menuItems = Array.isArray(item?.children) ? item.children : [];
  const hasOffset = offset === 'spaced';

  return (
    <Transition
      as={Fragment}
      show={isOpen}
      enter={transition.enter}
      enterFrom={transition.enterFrom}
      enterTo={transition.enterTo}
      leave={transition.leave}
      leaveFrom={transition.leaveFrom}
      leaveTo={transition.leaveTo}
    >
      <div
        className={classNames(
          'c-dropdown-menu',
          useGrid && 'c-dropdown-menu--grid',
          isCentered && 'c-dropdown-menu--centered',
          isCompact && 'c-dropdown-menu--compact',
          hasOffset && 'c-dropdown-menu--offset',
        )}
      >
        <div className="c-dropdown-menu__panel">
          <div className="c-dropdown-menu__content">
            <ul className="c-dropdown-menu__list">
              {menuItems.map((child, childIndex) => {
                const childKey = `${baseKey}-child-${childIndex}`;
                const navigationLinkStyling = child?.navigationLinkStyling;
                const linkStyleValue = typeof navigationLinkStyling === 'string'
                  ? navigationLinkStyling
                  : navigationLinkStyling?.value;
                const isSmallUppercase = linkStyleValue === 'smallUppercase';
                const isPromoLink = linkStyleValue === 'promoLink' || Boolean(child?.navigationPromoLink);
                const isPassive = child?.tag === 'span' || (!child?.url && !isSmallUppercase && !isPromoLink);
                const promoBody = typeof child?.navigationPromoBody === 'string'
                  ? child.navigationPromoBody.trim()
                  : '';

                return (
                  <li
                    key={childKey}
                    className={classNames(
                      'c-dropdown-menu__item',
                      isPassive
                        ? 'c-dropdown-menu__item--passive'
                        : isPromoLink
                          ? null
                          : 'c-dropdown-menu__item--link',
                      isSmallUppercase && 'c-dropdown-menu__item--small-uppercase',
                      isPromoLink && 'c-dropdown-menu__item--promo-link',
                    )}
                  >
                    {isPassive ? (
                      <span className="c-dropdown-menu__label">{child.title}</span>
                    ) : (
                      <a
                        {...mapLinkAttributes(child)}
                        title={child.title || undefined}
                      >
                        {isPromoLink ? (
                          <span className="c-dropdown-menu__promo-text">
                            <span className="c-dropdown-menu__promo-heading">{child.title}</span>
                            {promoBody !== '' && (
                              <span className="c-dropdown-menu__promo-body">{promoBody}</span>
                            )}
                          </span>
                        ) : (
                          child.title
                        )}
                        {isPromoLink && (
                          <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.5 1.5L9.5 10L1.5 18.5" stroke="black" strokeWidth="3" strokeLinecap="round"></path>
                          </svg>
                        )}
                      </a>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </Transition>
  );
}
